import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-column menu-column">
          <h4 className="footer-heading">Customer Care</h4>
          <nav className="footer-nav">
            <Link to="/contact" onClick={toTop}>
              Contact Us
            </Link>
            <Link to="/policies" onClick={toTop}>
              All Policies
            </Link>
            <Link to="/shipping" onClick={toTop}>
              Shipping &amp; Delivery
            </Link>
            <Link to="/returns" onClick={toTop}>
              Returns &amp; Refunds
            </Link>
            <Link to="/order-policy" onClick={toTop}>
              Orders &amp; Cancellations
            </Link>
            <Link to="/payment-policy" onClick={toTop}>
              Payment &amp; Billing
            </Link>
            <Link to="/warranty" onClick={toTop}>
              Product Warranty
            </Link>
            <Link to="/subscriptions" onClick={toTop}>
              Subscriptions
            </Link>
            <Link to="/promotions" onClick={toTop}>
              Promotions &amp; Gift Cards
            </Link>
            <Link to="/faqs" onClick={toTop}>
              FAQs
            </Link>
          </nav>
        </div>

        <div className="footer-column menu-column">
          <h4 className="footer-heading">Legal &amp; Policies</h4>
          <nav className="footer-nav">
            <Link to="/privacy" onClick={toTop}>Privacy Policy</Link>
            <Link to="/cookies" onClick={toTop}>Cookie Policy</Link>
            <Link to="/terms" onClick={toTop}>Terms of Service</Link>
            <Link to="/terms-of-sale" onClick={toTop}>Terms of Sale</Link>
            <Link to="/food-safety" onClick={toTop}>Food Safety &amp; Allergens</Link>
            <Link to="/accessibility" onClick={toTop}>Accessibility</Link>
            <Link to="/acceptable-use" onClick={toTop}>Acceptable Use</Link>
            <Link to="/intellectual-property" onClick={toTop}>Intellectual Property</Link>
            <Link to="/security" onClick={toTop}>Responsible Disclosure</Link>
            <Link to="/disclaimer" onClick={toTop}>Website Disclaimer</Link>
            <Link to="/legal-notice" onClick={toTop}>Legal Notice</Link>
          </nav>
        </div>

        <div className="footer-column newsletter-column">
          <h4 className="footer-heading">Connect</h4>
          <div className="newsletter-content">
            <p>
              <a href="mailto:zone@camartzuno.store">zone@camartzuno.store</a>
              <br />
              Pionierów 55, 42-202 Częstochowa, PL
            </p>
          </div>
        </div>

        <div className="footer-column social-column">
          <h4 className="footer-heading">camartzuno</h4>
          <p>
            Thoughtful food storage for everyday organization and meal prep.
          </p>
        </div>
      </div>
      <div className="footer-payments" aria-label="Supported payment methods">
        <span>Secure payments:</span>
        <strong>VISA</strong>
        <strong>Mastercard</strong>
        <strong>American Express</strong>
        <strong>Apple Pay</strong>
        <strong>Google Pay</strong>
      </div>
    </footer>
  );
}

export default Footer;
